// rest of imports
import { initAuth } from '@waitroom/auth';
import { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useStorageSync from '../../hooks/useStorageSync';
import CkConsent from '../CkConsent/CkConsent';
import AppBanner from './Banner/AppBanner';
import AppModals from './Modals/AppModals';
import AppNavigate from './Navigate/AppNavigate';
import Providers from './Providers/AppProviders';
import Routes from './Routes/AppRoutes';
import ScrollToTop from './ScrollToTop/ScrollToTop';
import Version from './Version/Version';

const App = (): ReactElement | null => {
  const dispatch = useDispatch();
  useStorageSync();

  useEffect(() => {
    dispatch(initAuth());
  }, [dispatch]);

  return (
    <Providers>
      <AppNavigate />
      <ScrollToTop />
      <Routes />
      <AppModals />
      <CkConsent />
      <Version />
      <AppBanner />
    </Providers>
  );
};

export default App;
